// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3eMNV","lds_facebook":"styles_lds_facebook__2Caxc"};